'use-client';
import { useRouter } from 'next/navigation';
import { FunctionComponent, useCallback } from 'react';
import styles from './styles.module.scss';
import Button from '../../../../../components/Button';
import ArrowLeftIcon from '../../../../../components/Icons/ArrowLeftIcon';

export const BackButton: FunctionComponent = () => {
    const router = useRouter();

    const goBack = useCallback(() => {
        router.back();
    }, [router]);

    if (typeof window !== 'undefined' && window.history?.length <= 1) {
        return null;
    }

    return (
        <div className={styles.buttonContainer}>
            <Button preset="textButton" onClick={goBack} className={styles.breadcrumbsBackButton}>
                <ArrowLeftIcon className={styles.leftArrow} />
                Back
            </Button>
        </div>
    );
};
